// extracted by mini-css-extract-plugin
module.exports = {"cover-letter-tabs":"CoverLetterDataWrapper_cover-letter-tabs__3jSIy","cover-letter-data-card-wrapper":"CoverLetterDataWrapper_cover-letter-data-card-wrapper__F_OnG"};